var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"penjurusan"}},[(_vm.isSplash == true)?_c('Splash'):_vm._e(),(_vm.isSplash == false)?_c('Landing'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }